import Vue from 'vue'

import auth                  from '@websanova/vue-auth/dist/v2/vue-auth.esm.js';
import driverHttpAxios       from '@websanova/vue-auth/dist/drivers/http/axios.1.x.esm';
import driverRouterVueRouter from '@websanova/vue-auth/dist/drivers/router/vue-router.2.x.esm.js';




export default Vue.use(auth, {
    plugins: {
        http: Vue.axios,
        router: Vue.router,
    },
    drivers: {
        auth:  {
            request: function (req, token) {
                this.drivers.http.setHeaders.call(this, req, {
                    Authorization: 'Bearer ' + token
                });

            },
            response: function (res) {
                let token = res.data.access_token
                if (token) {
                    token = token.split(/Bearer:?\s?/i);
                    return token[token.length > 1 ? 1 : 0].trim();
                }
            }
        },
        http: driverHttpAxios,
        router: driverRouterVueRouter,

    },
    options: {
        rolesKey: 'role',
        notFoundRedirect: {name: 'login'},
        parseUserData: function (data) {
            return data || {};
        },
        loginData : {
            url : "api/auth/login",
            redirect: '/',
            method: 'POST'
        },
        logoutData : {
            url : "api/auth/logout",
            redirect: '/login',
            method: 'POST'
        },
        fetchData : {
            url : "api/auth/me",
            method: 'POST'
        },
        refreshData : {
            url : "api/auth/refresh",
            method: 'POST',
            enabled: false
        }
    }
});
